var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bodywrapper" }, [
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-one-fifth" }),
      _c("div", { staticClass: "column" }, [
        _c("h1", [_vm._v("Event Series Published!")]),
        _c("p", [
          _vm._v(" Event series successfully published. You can find it at: "),
          _c(
            "a",
            {
              attrs: { href: "https://tix.gobo.show/series/" + _vm.series.id }
            },
            [_vm._v("https://tix.gobo.show/series/" + _vm._s(_vm.series.id))]
          )
        ])
      ]),
      _c("div", { staticClass: "column is-one-fifth" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }